import React from 'react'
import UsersAvatarGroup from 'components/shared/UsersAvatarGroup'

const Members = ({members,Drivers,SalesReps}) => {
	return <UsersAvatarGroup users={members} Drivers={Drivers} SalesReps={SalesReps} />
}

export default Members
